import ReportsList from "../components/Reports/ReportsList";
const ReportsPage = () => {

  return (
    <div>
      <ReportsList />
    </div>
  )
}
export default ReportsPage